<template>
  <div>
    <v-dialog v-model="open" persistent max-width="700">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <h1>Atualizar Data de Finalização</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>

          <div class="mt30"></div>
          <v-form ref="aditionalForm">
            <v-row>
              <v-col cols="12">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedCompletionDate"
                      label="Data de finalização"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="completionDate"
                    :active-picker.sync="activePicker1"
                    locale="pt-br"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
          <div class="mt10"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" large @click="close(false)"> Cancelar </v-btn>
          <v-btn
            color="success"
            class="flex-grow-1"
            :loading="isUpdateButtonLoading"
            :disabled="!completionDate"
            large
            @click="confirmUpdate()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError :type="errorsType" :errors="errors" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MessagesError from '@/components/MessagesError.vue';

export default {
  name: 'UpdateCompletionDate',
  props: {
    open: {
      default: false,
      type: Boolean
    },
    shipmentNode: {
      default: Array
    },
    nfeIds: {
      default: () => [],
      type: Array
    }
  },
  components: {
    MessagesError
  },
  data: () => ({
    isUpdateButtonLoading: false,
    completionDate: null,
    menu1: false,
    activePicker1: null,
    ids: [],
    message: [],
    errors: [],
    errorsType: 'error',
    error500: null,
    rules: [(value) => !!value || 'Required.']
  }),
  computed: {
    formattedCompletionDate() {
      if (!this.completionDate) return '';
      const [year, month, day] = this.completionDate.split('-');
      return `${day}/${month}/${year}`;
    }
  },
  watch: {
    open(val) {
      if (val) {
        if (this.shipmentNode.length) {
          const date = this.shipmentNode[0].completionDate;
          const day = date.split('/')[0];
          const month = date.split('/')[1];
          const year = date.split('/')[2];
          const newDate = `${year}-${month}-${day}`;
          this.completionDate = newDate;
        }
      }
    }
  },
  methods: {
    ...mapActions('ShipmentStore', ['changeCompletionDate']),
    ...mapActions('NfeStore', ['updateNfesCompletionDates']),

    close(hasChange, message) {
      this.$emit('closeModal', hasChange, message);
      this.$emit('update:open', false);
      this.completionDate = null;
    },

    async confirmUpdate() {
      if (this.shipmentNode.length) {
        await this.updateNumber();
      } else {
        await this.updateNfeCompletionDates();
      }
    },

    async updateNumber() {
      if (!this.completionDate) {
        this.completionDate = null;
        return;
      }

      var model = {
        nfeId: this.shipmentNode[0].id,
        completionDate: this.completionDate
      };

      try {
        const data = await this.changeCompletionDate(model);

        if (data.success) {
          this.message = {
            errors: ['A data de finalização foi atualizada com sucesso!'],
            errorsType: 'success'
          };
        } else {
          this.message = {
            errors: data.errors,
            errorsType: 'error'
          };
        }
      } catch (e) {
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.close(true, this.message);
      }
    },

    async updateNfeCompletionDates() {
      const model = {
        nfeIds: this.nfeIds,
        completionDate: this.completionDate
      };

      try {
        this.isUpdateButtonLoading = true;
        const data = await this.updateNfesCompletionDates(model);
        if (data.success) {
          this.handleSuccessFeedback();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        this.errors = error.errors;
        this.errorsType = 'error';
        console.error(error);
      } finally {
        this.isUpdateButtonLoading = false;
        this.setClearErrorTimer();
        this.close(true);
      }
    },

    handleSuccessFeedback() {
      this.errors = ['A data de finalização foi atualizada com sucesso!'];
      this.errorsType = 'success';
      this.$emit('shouldUpdateList');
      this.setClearErrorTimer();
    },

    setClearErrorTimer() {
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    }
  }
};
</script>

<style></style>
